module.exports = __webpack_public_path__ + "media/unipod/pod_construciton_4-e59ad26c.jpg";